import StepCard from './StepCard';

export default function HowToUse() {
  return (
    <section className="py-12 sm:py-16 md:py-20 px-4" id="how-to-use">
      <div className="max-w-5xl mx-auto">
        <h2 className="text-center text-2xl sm:text-3xl font-semibold mb-2">
          How it works
        </h2>
        <p className="text-gray-600 text-sm sm:text-base text-center max-w-2xl mx-auto mb-4">
          Creating a group event is as easy as 1-2-3-4. Just create a meeting
          planner, share the link, have everyone mark their availability, and
          pick the best time.
        </p>

        <div className="bg-white rounded-2xl px-6 py-5 border border-gray-200 shadow-lg hover:shadow-xl transition-shadow">
          {/* Steps grid */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            <StepCard
              num="1"
              badgeClass="bg-blue-100 text-blue-600"
              title="Create a meeting planner"
              description="Create a meeting planner with the dates you have in mind."
            />
            <StepCard
              num="2"
              badgeClass="bg-green-100 text-green-700"
              title="Share link"
              description="Share the generated link with your group."
            />
            <StepCard
              num="3"
              badgeClass="bg-yellow-100 text-yellow-700"
              title="Participate"
              description="Mark when you’re free by dragging on the grid."
            />
            <StepCard
              num="4"
              badgeClass="bg-purple-100 text-purple-700"
              title="Check results"
              description="Instantly spot the best overlap and lock in a time."
            />
          </div>
        </div>
      </div>
    </section>
  );
}
